<h1 mat-dialog-title>{{ "message.occurrence.restrict.dialog.title" | translate | async }}</h1>
<p mat-dialog-content>
   {{"message.occurrence.restrict.dialog" | translate | async }}
</p>
<div mat-dialog-actions>
  <vue-flat-button  (clicked)="closeDialog()">
    {{ "button.ok" | translate | async  }}
  </vue-flat-button>
</div>
